import { withI18n } from 'react-i18next';
import TrackingMobile from './TrackingInfoMobile';

export const pureComponent = TrackingMobile;
export default withI18n()(TrackingMobile);
